export const SOMETHING_WENT_WRONG_MODAL_NAME =
  'SOMETHING_WENT_WRONG_MODAL_NAME';
